/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import dayjs from "dayjs"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import ComboBox from "../../../components/ComboBox"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import KyuyuryoService from "../../../service/truckcontrol/kyuyuryo/kyuyuryoService"
import {
  TKyuyuryoGetListReq,
  TKyuyuryoGetListRes,
} from "../../../service/truckcontrol/kyuyuryo/TKyuyuryo"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { RootState } from "../../../globalStore/rootreducer"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import KyuyuryoEditModal from "./KyuyuryoEditModal"
import BusyoService from "../../../service/master/busyo/busyoService"
import Decimal from "decimal.js"
import { FunctionContext } from "../../../components/Context"
import commonUtil from "../../../ts/util/commonUtil"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"

/**
 * 給油量一覧
 * @returns
 */
const KyuyuryoList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "KyuyuryoRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TKyuyuryoGetListRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        合計: (i: TKyuyuryoGetListRes) => {
          const d宇佐美給油_合計数量 = new Decimal(i.宇佐美給油_合計数量 ?? 0)
          const d一光給油_合計数量 = new Decimal(i.一光給油_合計数量 ?? 0)
          const d自社給油_合計数量 = new Decimal(i.自社給油_合計数量 ?? 0)
          const d予備カード給油_合計数量 = new Decimal(
            i.予備カード給油_合計数量 ?? 0
          )
          const d中日本給油_合計数量 = new Decimal(i.中日本給油_合計数量 ?? 0)
          const d飯田運輸給油_合計数量 = new Decimal(
            i.飯田運輸給油_合計数量 ?? 0
          )
          const d現金給油_合計数量 = new Decimal(i.現金給油_合計数量 ?? 0)

          return d宇佐美給油_合計数量
            .plus(d一光給油_合計数量)
            .plus(d自社給油_合計数量)
            .plus(d予備カード給油_合計数量)
            .plus(d中日本給油_合計数量)
            .plus(d飯田運輸給油_合計数量)
            .plus(d現金給油_合計数量)
            .toNumber()
        },

        sort_部所コード: (i: TKyuyuryoGetListRes) =>
          commonUtil.createSortString(
            i.部所コード,
            VALIDATE_CONSTANT.LENGTH.部所コード
          ),
        sort_社員コード: (i: TKyuyuryoGetListRes) =>
          commonUtil.createSortString(
            i.社員コード,
            VALIDATE_CONSTANT.LENGTH.社員コード
          ),
      },

      sortDescriptions: [
        new wjCore.SortDescription("sort_部所コード", true),
        new wjCore.SortDescription("sort_社員コード", true),
      ],

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  // 検索前処理
  const beforeSearch = () => {
    // TODO:バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    dispatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // nullチェック
    // 荷主情報はモーダル画面で設定させるので、コードのみ判定
    if (年月 == null) {
      messages.push(`年月 を入力してください。`)
      hasError = true
    }

    // error判定とメッセージセット
    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    return !hasError
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TKyuyuryoGetListReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TKyuyuryoGetListReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new KyuyuryoService().getList(currentSearchCondition)
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // uniqueな荷主の明細を取得
      setGridData({
        data: createCollectionView(res.data, pageSize),
      })
      // アコーディオン部分一旦そのまま
      // setAccordionController(false)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TKyuyuryoGetListReq = queryString.parse(location.search)
    set年月(query.年月!)
    set部所コード(query.部所コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TKyuyuryoGetListReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TKyuyuryoGetListReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set年月(eigyobi)
    set部所コード("")
    set部所(undefined)
    set部所ItemSource(undefined)

    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
    // フォーマットのループ制御
    // ref明細フォーマットフラグ.current = true
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // modal
  // 給油量編集
  const [乗務員ID, set乗務員ID] = useState<number>()
  const [is給油量編集Modal, setIs給油量編集Modal] = useState<boolean>(false)

  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] =
    useState<TKyuyuryoGetListReq>({} as TKyuyuryoGetListReq)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  // state
  const [年月, set年月] = useState<string>(eigyobi)

  // ComboBox
  // 部所
  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `給油量登録`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())

    // 年月項目に初期値としてシステム日を入れる
    set年月(eigyobi)
  }, [])

  // TODO:APIから取得する
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      dispatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  // modal制御用
  // useEffect(() => {
  //   // ステート変数の更新確認してからモーダルを表示する。
  //   if (!isChangeStateFlg) return
  //   setIs給油量編集Modal(true)
  // }, [isChangeStateFlg])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">給油量一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-80rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <ul className="list-cmn d-flex">
                          <li className="list-cmn">
                            <MonthInput
                              id="年月"
                              value={年月}
                              setValue={(v) => {
                                set年月(v ?? eigyobi)
                              }}
                              isRequired
                              placeholder="年月"
                            />
                          </li>

                          <li className="list-cmn list-padding">
                            <ComboBox.Busyo
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              selectedValue={部所コード}
                              setSelectedItem={set部所}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            beforeSearch()
                          }}>
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <FunctionContext.Provider
        value={() => {
          search(preSearchCondition)
        }}>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>

                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  isShowGridRowPickupButton={true}
                  // gridProperties={{
                  //   allowDragging: wjcGrid.AllowDragging.None,
                  // }}
                >
                  <wjrGrid.FlexGridColumn
                    binding="部所名"
                    width={170}
                    sortMemberPath="sort_部所コード"
                    header="部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員コード"
                    width={90}
                    sortMemberPath="sort_社員コード"
                    header="コード"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員氏名"
                    width={160}
                    header="乗務員"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="合計"
                    width={110}
                    format="N2"
                    header="合計"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="宇佐美給油_合計数量"
                    width={110}
                    format="N2"
                    header="宇佐美"></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="一光給油_合計数量"
                    width={110}
                    format="N2"
                    header="ENEOS"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="自社給油_合計数量"
                    width={110}
                    format="N2"
                    header="自社"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="予備カード給油_合計数量"
                    width={110}
                    format="N2"
                    header="予備カード"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="中日本給油_合計数量"
                    width={110}
                    format="N2"
                    header="中日本"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="飯田運輸給油_合計数量"
                    width={110}
                    format="N2"
                    header="飯田"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現金給油_合計数量"
                    width={110}
                    format="N2"
                    header="現金"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    header=" "
                    align="center"
                    width={80}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TKyuyuryoGetListRes>
                      ) => {
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              set乗務員ID(context.item.乗務員ID)
                              setIs給油量編集Modal(true)
                            }}>
                            手入力
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <KyuyuryoEditModal
          title="給油量手入力"
          isShow={is給油量編集Modal}
          setIsShow={(v) => {
            setIs給油量編集Modal(v)
          }}
          年月={preSearchCondition.年月!}
          乗務員ID={乗務員ID!}></KyuyuryoEditModal>
      </FunctionContext.Provider>
    </Container>
  )
}

export default KyuyuryoList
